import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/leaf-simple.svg'


const _withScopeId = n => (_pushScopeId("data-v-7932f098"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-error" }
const _hoisted_2 = { class: "main-error__figure" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "main-error__img",
  alt: "Error",
  src: _imports_0,
  width: "88",
  height: "140"
}, null, -1))
const _hoisted_4 = { class: "main-error__text" }

import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheError',
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("figure", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("figcaption", _hoisted_4, _toDisplayString(_unref(t)('component_the_error_text')), 1)
    ])
  ]))
}
}

})